import $ from 'jquery';
import { INPUT_GROUP_CONTAINER_SELECTOR } from 'stdjs/form-element';

var parentElementSelector = INPUT_GROUP_CONTAINER_SELECTOR;

export function initPasswordField( $passwordField ){
    
    $passwordField = $( $passwordField );
    var $parentElement = $passwordField.closest( parentElementSelector );
    
    $parentElement.on( "click", '.password-visibility', function( e ){    
        // TODOUI make this a standard functionality for button toggles
        // HAndle having multiple different toggles in the same input group
        $parentElement.find( '.button-toggle-add-on-container-on' ).toggleClass( 'hidden' );
        $parentElement.find( '.button-toggle-add-on-container-off' ).toggleClass( 'hidden' );
        
        if ( $( e.currentTarget ).hasClass( 'password-show' ) ){
            $parentElement.find( 'input' ).attr( 'type', 'text' );
        } else {
            $parentElement.find( 'input' ).attr( 'type', 'password' );
        }
    });
    
}
